<template>
  <div class="toast-stack-container">
    <div
      v-for="toast in toasts"
      :key="toast.id"
      :class="['toast', 'align-items-center', 'text-white', 'border-0', toast.color, 'show']"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      <div class="d-flex align-items-center">
        <div class="toast-body d-flex align-items-center flex-grow-1">
          <span class="flex-grow-1">{{ toast.message }}</span>
          <div v-if="toast.loading" class="spinner-border text-white ms-2 flex-shrink-0" role="status">
            <span class="visually-hidden">Laden...</span>
          </div>
        </div>
        <button
          type="button"
          class="btn-close btn-close-white me-2 m-auto flex-shrink-0"
          @click="removeToast(toast.id)"
          aria-label="Close"
        ></button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToastStack',
  data() {
    return {
      toasts: [],
      nextId: 1
    };
  },
  methods: {
    addToast(message, color = 'bg-info', loading = false, autoHide = false, duration = 3000) {
      const id = this.nextId++;
      const toast = {
        id,
        message,
        color,
        loading
      };
      
      this.toasts.push(toast);
      
      if (autoHide) {
        setTimeout(() => {
          this.removeToast(id);
        }, duration);
      }
      
      return id;
    },
    removeToast(id) {
      const index = this.toasts.findIndex(t => t.id === id);
      if (index !== -1) {
        this.toasts.splice(index, 1);
      }
    },
    updateToast(id, updates) {
      const toast = this.toasts.find(t => t.id === id);
      if (toast) {
        Object.assign(toast, updates);
      }
    }
  }
};
</script>

<style scoped>
.toast-stack-container {
  position: fixed;
  top: 5rem;
  left: 1rem;
  z-index: 1055;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-width: 400px;
}

.toast {
  min-width: 300px;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

.spinner-border {
  width: 1.25rem;
  height: 1.25rem;
  border-width: 0.2em;
  flex-shrink: 0;
}

@media (max-width: 576px) {
  .toast-stack-container {
    left: 0.5rem;
    right: 0.5rem;
    max-width: calc(100% - 1rem);
  }
  
  .toast {
    min-width: unset;
    width: 100%;
  }
}
</style>

